import {trackExperimentActivation} from '@aboutyou/legacy-tracking-sdk';
import {useCallback} from 'react';
import {useTracking} from '../utils/utils';

export const useExperimentActivation = () => {
  const {TrackingClient} = useTracking();

  return useCallback(
    (experiment: {name: string; value: string}) => {
      TrackingClient.track(
        trackExperimentActivation({
          testName: experiment.name,
          testVariation: experiment.value,
        }),
      );
    },
    [TrackingClient],
  );
};
